var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('profile-dialog'),_c('transition',{attrs:{"name":"fade","duration":{ enter: 2000, leave: 2000 }}},[(_vm.loading)?_c('div',{staticClass:"loader"}):_vm._e()]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }